import { EquipmentCategory } from "@/types/equipment";

// 按分类 id 在分类树中递归查找，返回命中的分类节点，未找到返回 undefined
export const findEquipmentCategory = (
  nodes: EquipmentCategory[],
  id: string,
): EquipmentCategory | undefined => {
  // 深度优先遍历，命中后立即返回，避免继续扫描无关分支。
  for (const node of nodes) {
    if (node.id === id) return node;

    const found = findEquipmentCategory(node.subs ?? [], id);
    if (found) return found;
  }

  return undefined;
};

// 按分类 id 在分类树中递归查找，返回从根到该分类的 id 路径（常用于 TreeSelect 回显），未找到返回 undefined
export const findEquipmentCategoryPath = (
  nodes: EquipmentCategory[],
  id: string,
  parentPath: string[] = [],
): string[] | undefined => {
  for (const node of nodes) {
    // 每层创建新路径，避免递归过程中修改父级路径数组。
    const currentPath = [...parentPath, node.id];
    if (node.id === id) return currentPath;

    const foundPath = findEquipmentCategoryPath(node.subs ?? [], id, currentPath);
    if (foundPath) return foundPath;
  }

  return undefined;
};
